import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;
  const logo = (
    <Box sx={{ width: 40, height: 40, ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%"  viewBox="0 0 1024.000000 1024.000000">
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g
          fill={PRIMARY_MAIN} stroke="none" strokeWidth="1" fillRule="evenodd"  transform="translate(0.000000,1024.000000) scale(0.100000,-0.100000)">
          <path d="M7766 8294 c-4 -14 -5 -28 -3 -31 3 -2 8 8 11 23 4 14 5 28 3 31 -3
2 -8 -8 -11 -23z"/>
<path d="M7702 8230 c0 -8 4 -26 8 -40 6 -20 8 -21 8 -5 0 11 -3 29 -8 40 -5
12 -8 14 -8 5z"/>
<path d="M7732 8215 c-1 -37 -9 -76 -18 -84 -4 -3 -5 1 -2 9 3 8 -1 21 -9 29
-12 11 -14 11 -12 0 1 -8 -1 -21 -4 -29 -12 -28 -24 -131 -16 -136 4 -2 13 12
19 33 5 21 15 45 21 53 9 12 9 11 4 -5 -12 -33 -35 -129 -34 -145 1 -24 28 66
50 165 32 142 32 142 21 126 -8 -11 -10 -11 -15 0 -2 8 -5 1 -5 -16z"/>
<path d="M4861 7999 c-270 -26 -496 -91 -738 -213 -142 -71 -200 -108 -321
-205 -416 -336 -676 -787 -733 -1271 -18 -157 -6 -414 26 -560 14 -63 25 -117
25 -119 0 -2 -40 -1 -88 2 -192 14 -343 90 -389 197 -25 61 -14 164 27 246 52
103 177 247 300 348 51 41 18 22 -85 -50 -121 -83 -157 -113 -244 -197 -188
-184 -261 -366 -201 -505 97 -224 528 -261 1135 -96 507 138 1207 450 1620
724 39 26 95 62 125 81 198 123 671 460 715 509 16 18 16 20 -9 53 -14 19 -26
39 -26 44 0 12 -127 123 -141 123 -26 0 -3 -43 50 -93 33 -31 55 -59 50 -63
-5 -3 -9 -11 -9 -19 0 -8 -12 -26 -26 -40 -19 -19 -31 -24 -47 -19 -20 7 -19
8 11 16 55 15 50 32 -34 114 -71 69 -79 75 -101 65 -13 -6 -39 -11 -58 -11
-28 0 -36 -5 -40 -22 -3 -13 -22 -33 -41 -46 -22 -15 -37 -33 -41 -53 -7 -35
-36 -57 -93 -70 -33 -7 -48 -5 -79 11 -38 19 -60 58 -45 81 3 6 9 34 13 63 l6
51 91 -3 c87 -2 92 -1 97 20 8 31 -12 69 -50 93 -37 23 -42 35 -14 35 11 0 23
5 26 10 3 6 13 10 22 10 24 0 99 52 117 82 10 16 29 29 53 35 36 8 38 11 41
50 5 66 45 68 72 3 13 -32 26 -35 120 -30 56 3 78 14 82 42 2 18 9 23 31 21
26 -2 28 0 23 22 -6 24 -5 25 48 25 45 0 54 -3 59 -20 3 -12 14 -20 26 -20 16
0 21 -6 21 -25 0 -14 4 -25 9 -25 11 0 41 -125 41 -169 0 -16 -6 -32 -12 -35
-7 -3 -2 -3 12 0 24 5 24 4 6 -10 -10 -9 -23 -13 -29 -9 -6 3 -7 1 -3 -6 6 -9
-106 -146 -152 -185 -44 -37 -55 -50 -44 -54 12 -4 64 39 237 192 137 122 225
206 225 215 0 12 -179 182 -260 247 -378 304 -914 461 -1409 413z m324 -38
c26 -6 30 -11 28 -37 -3 -36 -45 -134 -67 -157 -9 -8 -53 -28 -98 -43 -45 -15
-94 -38 -107 -50 -14 -13 -47 -31 -73 -40 -51 -16 -74 -42 -128 -137 -35 -62
-39 -64 -105 -42 -16 5 -21 2 -22 -13 -1 -12 9 -22 31 -30 52 -19 72 -14 110
28 20 22 44 40 53 40 18 0 76 -17 111 -33 43 -20 141 -117 154 -153 l13 -36
55 6 c30 4 73 9 95 11 29 4 20 -1 -30 -16 -38 -11 -75 -22 -82 -24 -9 -3 -8
-20 3 -67 29 -122 17 -287 -21 -288 -5 0 -19 -18 -30 -40 -11 -22 -24 -40 -30
-41 -5 0 -17 -6 -25 -13 -8 -8 -32 -20 -54 -27 -21 -8 -41 -20 -43 -26 -3 -7
-12 -13 -19 -13 -8 0 -17 -6 -20 -14 -3 -7 -23 -16 -45 -20 -21 -3 -39 -12
-39 -19 0 -8 -3 -8 -9 2 -5 7 -14 10 -20 7 -6 -4 -14 -1 -17 8 -3 8 -11 17
-18 19 -9 4 -7 -7 6 -35 29 -60 18 -83 -15 -30 -26 40 -47 54 -47 31 0 -5 -8
-9 -17 -7 -10 1 -23 0 -28 -4 -6 -4 -47 -8 -90 -9 -72 -2 -81 0 -91 19 -9 18
-13 14 -35 -45 -31 -82 -40 -89 -23 -15 17 73 18 90 3 75 -12 -12 -69 -6 -79
7 -5 7 -69 43 -82 46 -5 1 -12 2 -18 3 -5 0 -7 15 -3 33 6 31 6 31 -15 12 -42
-38 -53 -46 -60 -39 -4 4 -1 10 6 12 6 3 12 11 12 19 0 8 7 17 15 20 8 4 15
13 15 21 0 10 -5 11 -16 5 -12 -7 -22 -4 -35 9 -11 11 -19 23 -19 28 0 6 -11
22 -25 37 l-26 28 40 12 c49 14 107 49 115 69 3 8 4 15 2 15 -15 0 -105 -36
-118 -47 -17 -15 -35 -2 -23 17 11 17 -39 11 -72 -10 -18 -11 -38 -29 -45 -41
-7 -11 -31 -30 -52 -41 -50 -26 -71 -51 -91 -108 -10 -30 -26 -53 -48 -68 -18
-12 -47 -36 -63 -53 -27 -28 -29 -36 -29 -109 0 -79 -9 -106 -25 -80 -10 16
-14 42 -10 73 2 28 -17 45 -60 52 -51 9 -81 -1 -73 -23 5 -14 3 -15 -8 -4 -7
6 -25 12 -40 12 -31 0 -44 13 -33 32 5 7 7 29 5 49 -1 20 2 40 8 44 6 3 11 40
11 86 0 46 4 79 10 79 18 0 10 17 -12 27 -23 11 -23 11 5 18 16 4 26 13 24 19
-7 17 12 119 24 131 5 5 9 22 9 38 0 31 21 74 57 120 12 15 21 33 19 40 -1 6
-1 9 1 5 6 -10 33 2 33 14 0 5 10 24 22 41 22 30 33 71 16 61 -4 -3 -5 2 -2
10 3 9 10 13 15 10 5 -3 12 2 15 11 4 9 30 38 57 63 28 26 70 66 93 90 23 23
48 42 56 42 8 0 31 18 52 40 47 50 60 51 52 5 -4 -19 -3 -35 2 -35 5 0 28 14
50 30 23 17 47 30 54 30 8 0 5 5 -4 11 -23 13 -23 32 0 52 19 17 52 26 124 32
60 5 135 -33 144 -73 3 -15 18 -37 31 -49 31 -25 26 -48 -13 -65 -22 -10 -28
-10 -32 0 -2 6 -10 12 -17 12 -10 0 -12 -7 -5 -29 9 -32 -3 -51 -31 -51 -9 0
-19 -7 -22 -15 -8 -18 -56 -3 -83 26 -10 12 -30 19 -51 19 -44 0 -39 21 6 33
51 13 81 36 81 62 0 33 -26 55 -65 55 -29 0 -35 -5 -56 -47 -17 -35 -32 -51
-54 -58 -41 -13 -40 -12 -25 -40 16 -30 15 -30 -34 -39 -36 -7 -38 -6 -33 13
7 27 6 27 -64 -10 -73 -39 -117 -80 -125 -116 -3 -16 -7 -34 -10 -41 -2 -7 22
-25 55 -42 l59 -29 -11 -36 c-9 -30 -8 -38 6 -52 20 -21 30 -12 47 40 7 22 27
50 50 68 30 24 40 41 45 73 4 22 13 48 20 56 8 8 18 27 24 43 9 22 16 27 46
27 21 0 48 -9 65 -22 26 -19 29 -26 24 -55 -5 -27 -3 -33 11 -33 9 0 31 12 47
26 37 31 48 23 55 -40 4 -35 12 -52 32 -67 l26 -21 13 33 c10 24 11 39 3 56
-6 13 -11 38 -11 56 1 27 2 30 13 16 9 -12 18 -14 37 -7 59 23 132 15 151 -15
12 -18 20 49 9 77 -14 39 -12 121 4 161 8 18 12 36 9 38 -3 3 2 30 11 60 9 30
16 65 16 77 0 22 -2 23 -75 16 -113 -10 -98 10 41 58 40 13 76 20 80 16 5 -4
36 -2 69 5 63 14 385 18 440 6z m-742 -72 c-24 -11 -57 -22 -75 -24 -24 -4
-16 2 27 19 72 30 108 34 48 5z m-153 -59 c-8 -5 -26 -9 -40 -9 -23 0 -23 1
-5 9 11 5 29 9 40 9 17 1 17 -1 5 -9z m1230 -100 c0 -5 -4 -10 -10 -10 -5 0
-10 5 -10 10 0 6 5 10 10 10 6 0 10 -4 10 -10z m479 -11 c45 -25 80 -69 56
-69 -8 0 -29 -13 -47 -30 -17 -16 -35 -30 -41 -30 -6 0 -7 -17 -4 -42 4 -30 0
-52 -13 -78 -22 -43 -36 -56 -71 -65 -24 -6 -29 -2 -49 39 -21 45 -23 46 -60
40 -35 -6 -40 -4 -55 26 -26 50 -17 70 52 116 35 22 73 50 86 62 21 20 81 51
101 52 4 0 25 -9 45 -21z m-701 -51 c22 -22 12 -39 -34 -59 -43 -20 -159 -34
-149 -20 2 4 -2 19 -10 34 -19 36 -4 45 80 50 39 1 77 4 86 5 8 1 20 -3 27
-10z m-1089 -19 c-16 -10 -23 -4 -14 10 3 6 11 8 17 5 6 -4 5 -9 -3 -15z
m1875 -38 c-12 -8 -14 -42 -3 -35 5 3 9 2 9 -3 0 -4 3 -18 6 -30 5 -19 2 -23
-17 -23 -24 0 -59 26 -59 44 0 15 53 64 64 59 4 -3 4 -8 0 -12z m-540 -80 c3
-5 -1 -15 -10 -22 -14 -11 -13 -15 7 -30 19 -14 21 -20 10 -32 -15 -19 5 -55
52 -91 30 -24 30 -25 14 -50 -17 -26 -28 -30 -105 -41 -38 -5 -43 -3 -39 12 3
10 8 36 11 58 5 34 4 37 -7 22 -28 -42 -33 -47 -68 -61 -47 -19 -58 -10 -50
39 5 35 12 43 48 60 35 16 42 25 43 48 0 20 8 33 29 45 17 9 32 25 35 34 4 19
21 24 30 9z m-1494 -21 c0 -5 -5 -10 -11 -10 -5 0 -7 5 -4 10 3 6 8 10 11 10
2 0 4 -4 4 -10z m-385 -148 c-3 -3 -11 0 -18 7 -9 10 -8 11 6 5 10 -3 15 -9
12 -12z m2129 -398 c4 -9 4 -19 2 -22 -10 -9 -36 8 -36 23 0 20 26 19 34 -1z
m27 -121 c1 -16 0 -32 -2 -38 -1 -5 -3 -19 -3 -31 -1 -11 -6 -21 -11 -21 -12
0 -149 -93 -153 -105 -2 -4 -8 -8 -12 -8 -5 0 -40 -22 -77 -50 -37 -27 -86
-62 -108 -78 -22 -17 -53 -37 -70 -46 -16 -10 -48 -28 -70 -41 -51 -31 -133
-75 -139 -75 -2 0 -7 29 -11 63 -6 57 -4 69 19 113 33 65 53 87 103 118 32 20
44 34 49 61 4 25 20 46 59 80 46 38 57 44 84 39 20 -4 49 1 83 14 65 26 83 29
181 31 l77 1 1 -27z m-2138 -457 c18 -8 46 -26 62 -39 25 -21 27 -26 13 -32
-10 -4 -33 7 -64 30 -35 27 -55 36 -76 33 -28 -5 -39 6 -15 15 22 10 47 7 80
-7z m-173 -49 c-27 -15 -36 -14 -25 2 3 6 16 11 28 11 21 0 21 -1 -3 -13z m3
-22 c-3 -9 -8 -14 -10 -11 -3 3 -2 9 2 15 9 16 15 13 8 -4z m360 -19 c9 -7 17
-16 17 -19 0 -10 -48 -17 -78 -11 -28 6 -29 7 -14 25 19 22 49 24 75 5z m87
-36 c0 -5 -7 -10 -16 -10 -8 0 -12 5 -9 10 3 6 10 10 16 10 5 0 9 -4 9 -10z
m77 -82 c-3 -7 -5 -2 -5 12 0 14 2 19 5 13 2 -7 2 -19 0 -25z m-122 -102 c29
-9 47 -10 64 -3 15 7 25 7 29 1 4 -6 28 -29 53 -52 37 -33 56 -43 92 -47 49
-5 78 -18 94 -44 9 -14 -1 -16 -96 -13 -58 1 -110 7 -115 12 -6 6 -20 10 -31
10 -12 0 -40 12 -61 28 -21 15 -58 36 -81 46 -23 10 -53 31 -67 45 l-26 28 39
-1 c21 -1 37 3 33 8 -3 6 3 6 14 2 10 -4 37 -13 59 -20z"/>
<path d="M4287 7174 c-3 -4 -38 -6 -77 -5 -47 1 -80 -4 -101 -15 -36 -18 -34
-29 3 -15 37 14 51 0 43 -43 -7 -34 -6 -36 20 -36 18 0 29 6 32 19 3 11 17 23
32 26 30 8 92 75 69 75 -8 0 -17 -3 -21 -6z"/>
<path d="M3450 6610 c-18 -12 -2 -12 25 0 13 6 15 9 5 9 -8 0 -22 -4 -30 -9z"/>
<path d="M4120 5936 c0 -2 15 -6 34 -8 19 -2 32 0 30 4 -5 8 -64 12 -64 4z"/>
<path d="M7660 7876 c-6 -8 -10 -25 -8 -36 2 -17 5 -14 14 14 12 40 12 42 -6
22z"/>
<path d="M7363 7744 c-2 -7 1 -23 7 -36 10 -22 10 -22 -4 -4 -13 16 -18 17
-31 6 -18 -15 -20 -37 -3 -42 7 -3 3 -13 -11 -27 -19 -19 -25 -21 -32 -10 -5
8 -9 17 -9 21 0 4 -9 6 -19 5 -11 0 -18 -4 -15 -8 2 -4 -6 -16 -19 -26 -21
-16 -22 -20 -10 -32 8 -7 21 -10 29 -7 16 6 19 -10 3 -19 -5 -4 -19 1 -29 10
-17 15 -18 15 -17 -12 1 -15 6 -31 12 -35 5 -4 -2 -8 -17 -8 -19 0 -26 -4 -22
-14 3 -8 -8 -23 -27 -36 -31 -23 -31 -23 -20 -2 7 12 16 22 21 22 18 0 10 19
-10 25 -11 3 -20 13 -20 21 0 8 -3 14 -6 14 -24 0 -114 -76 -114 -97 0 -7 -9
-13 -20 -13 -14 0 -20 -7 -20 -21 0 -24 -37 -58 -62 -59 -11 0 -18 -8 -18 -21
0 -24 -37 -58 -62 -59 -10 0 -18 -7 -18 -15 0 -20 -47 -65 -68 -65 -10 0 -30
-20 -47 -45 -18 -29 -46 -56 -77 -73 -33 -18 -46 -32 -43 -42 4 -8 3 -11 -1
-7 -4 4 -20 -11 -36 -33 -17 -22 -34 -40 -39 -40 -5 0 -9 -4 -9 -10 0 -5 8 -6
18 -3 15 6 15 5 4 -10 -8 -8 -19 -14 -25 -11 -7 2 -28 -7 -47 -21 -19 -14 -38
-25 -42 -25 -4 0 -17 -8 -27 -17 -37 -34 -104 -88 -138 -111 -18 -12 -33 -28
-33 -33 0 -6 -7 -9 -15 -5 -19 7 -19 1 -1 -17 13 -13 12 -14 -9 -14 -13 0 -33
-10 -46 -22 -13 -11 -26 -21 -31 -21 -4 0 -5 -7 -2 -15 4 -11 2 -13 -9 -10 -9
4 -26 -9 -48 -36 -18 -23 -35 -37 -37 -30 -2 6 -9 11 -14 11 -6 0 -9 -2 -6 -5
3 -3 -8 -19 -24 -35 -16 -17 -26 -35 -22 -41 4 -7 0 -9 -13 -5 -10 3 -28 -1
-39 -9 -10 -8 -14 -15 -6 -15 6 0 12 -5 12 -11 0 -6 -7 -8 -16 -5 -11 4 -18
-1 -21 -14 -5 -20 -12 -22 -65 -22 -15 -1 -25 -5 -22 -9 3 -5 -3 -9 -13 -10
-10 0 -5 -4 12 -10 26 -8 42 0 175 89 194 129 251 172 244 184 -4 6 -1 9 7 6
8 -3 32 9 55 26 22 17 67 51 100 75 169 126 364 285 504 411 52 46 97 86 100
88 2 2 -2 8 -10 13 -11 8 -10 9 7 4 20 -5 59 29 268 238 150 150 248 240 255
235 7 -5 7 -4 0 4 -13 16 -90 18 -97 2z m27 2 c0 -3 -4 -8 -10 -11 -5 -3 -10
-1 -10 4 0 6 5 11 10 11 6 0 10 -2 10 -4z m20 -17 c-7 -11 -14 -18 -17 -15 -3
3 0 12 7 21 18 21 23 19 10 -6z m-505 -488 c-6 -5 -25 10 -25 20 0 5 6 4 14
-3 8 -7 12 -15 11 -17z m-55 -57 c-8 -8 -23 -20 -34 -26 -14 -6 -11 -1 8 16
32 29 45 34 26 10z m-432 -318 c-7 -8 -15 -12 -17 -11 -5 6 10 25 20 25 5 0 4
-6 -3 -14z m-123 -106 c-3 -5 -11 -10 -16 -10 -6 0 -7 5 -4 10 3 6 11 10 16
10 6 0 7 -4 4 -10z m-305 -240 c0 -5 -7 -10 -16 -10 -8 0 -12 5 -9 10 3 6 10
10 16 10 5 0 9 -4 9 -10z m-85 -60 c-3 -5 -11 -10 -16 -10 -6 0 -7 5 -4 10 3
6 11 10 16 10 6 0 7 -4 4 -10z"/>
<path d="M7476 7745 c4 -8 11 -15 16 -15 6 0 5 6 -2 15 -7 8 -14 15 -16 15 -2
0 -1 -7 2 -15z"/>
<path d="M7625 7730 c-4 -17 -5 -34 -2 -36 3 -3 8 9 12 26 4 17 5 34 2 36 -3
3 -8 -9 -12 -26z"/>
<path d="M7284 7664 c6 -12 16 -19 23 -17 19 7 16 17 -10 29 -22 10 -23 9 -13
-12z"/>
<path d="M7500 7676 c10 -13 40 -12 40 1 0 3 -7 3 -15 -1 -8 -3 -15 -1 -15 4
0 6 -5 10 -11 10 -8 0 -8 -4 1 -14z"/>
<path d="M7611 7667 c-1 -10 -5 -16 -10 -13 -5 4 -7 -4 -3 -16 l5 -22 9 24 c5
13 7 28 4 34 -2 6 -5 3 -5 -7z"/>
<path d="M7540 7638 c0 -7 40 -78 45 -78 1 0 5 9 8 19 3 14 1 18 -9 14 -8 -3
-14 -1 -14 4 0 11 -29 51 -30 41z"/>
<path d="M7575 7630 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0
-7 -4 -4 -10z"/>
<path d="M7150 7254 l-50 -47 0 -1114 0 -1113 28 6 c137 31 365 105 500 161
l62 26 0 1064 0 1063 -245 0 -246 0 -49 -46z"/>
<path d="M6428 6699 l-48 -41 0 -895 0 -896 73 7 c91 9 385 53 455 68 l52 11
-1 651 c-1 432 -4 639 -10 616 -18 -65 -20 -67 -33 -35 -12 29 -13 29 -25 10
-12 -18 -23 -20 -124 -20 -173 1 -207 -3 -217 -29 -8 -19 -9 -19 -9 7 -1 27
-2 28 -18 11 -17 -16 -18 -63 -22 -626 -1 -334 -6 -608 -10 -608 -3 0 -5 134
-5 298 1 163 -1 570 -5 905 l-6 607 -47 -41z"/>
<path d="M5695 6348 c-6 -12 -25 -27 -44 -33 -18 -6 -38 -18 -45 -26 -6 -8
-19 -18 -29 -22 -10 -4 -16 -10 -13 -15 2 -4 -16 -21 -42 -37 -26 -16 -53 -35
-60 -42 -7 -7 -18 -13 -24 -13 -6 0 -9 -3 -5 -6 8 -9 277 158 271 168 -3 4 0
17 6 28 6 11 7 20 3 20 -5 0 -13 -10 -18 -22z m-10 -38 c-3 -5 -14 -10 -23 -9
-14 0 -13 2 3 9 27 11 27 11 20 0z m-55 -30 c0 -5 -4 -10 -10 -10 -5 0 -10 5
-10 10 0 6 5 10 10 10 6 0 10 -4 10 -10z"/>
<path d="M5730 6345 c-16 -19 0 -19 26 0 16 12 16 14 3 15 -9 0 -22 -7 -29
-15z"/>
<path d="M5723 6204 l-43 -36 0 -644 0 -644 -65 0 -65 0 0 193 c0 105 -3 235
-6 288 l-7 97 -76 -24 c-121 -38 -330 -94 -351 -94 -20 0 -34 -30 -26 -57 2
-10 1 -90 -3 -178 -8 -163 -8 -169 -16 678 0 20 -2 37 -5 37 -3 -1 -24 -18
-47 -39 l-43 -39 0 -412 0 -412 -27 6 c-16 3 -49 8 -75 12 l-48 6 0 364 c0
200 -2 364 -4 364 -2 0 -48 -19 -102 -41 -220 -92 -519 -196 -824 -285 -209
-62 -231 -68 -414 -114 -88 -22 -161 -42 -164 -45 -14 -14 180 -258 277 -348
123 -113 277 -218 411 -281 39 -18 67 -35 64 -39 -4 -4 2 -7 14 -7 12 0 72
-14 134 -31 252 -68 500 -89 1074 -89 465 0 609 10 954 69 214 36 670 165 890
251 534 209 874 412 956 572 13 26 24 49 24 51 0 2 -24 -19 -52 -46 -207 -191
-762 -388 -1401 -496 -370 -63 -588 -81 -993 -81 -392 0 -673 29 -1032 106
-215 46 -284 64 -467 125 -165 55 -275 97 -290 112 -6 7 -3 8 9 3 87 -31 416
-105 621 -140 164 -28 488 -65 675 -77 188 -12 864 -6 1000 9 l65 7 3 414 2
413 -22 -5 c-13 -3 -113 -37 -223 -75 l-200 -70 -7 -263 c-4 -145 -9 -275 -11
-289 -4 -24 -9 846 -7 1128 1 72 -3 132 -7 132 -4 0 -27 -16 -50 -36z"/>
<path d="M5372 6126 c-18 -13 -36 -27 -40 -31 -10 -11 50 21 73 39 32 25 3 17
-33 -8z"/>
<path d="M5285 6070 c-3 -6 1 -7 9 -4 18 7 21 14 7 14 -6 0 -13 -4 -16 -10z"/>
<path d="M2295 5693 c-21 -37 -48 -92 -59 -122 -24 -69 -26 -181 -3 -231 56
-125 238 -189 510 -177 147 6 347 34 347 49 0 5 -13 7 -29 3 -22 -5 -35 -1
-55 18 -26 25 -36 44 -14 31 7 -4 8 -3 4 4 -4 7 -20 12 -35 12 -15 0 -42 7
-59 16 -17 8 -41 16 -52 17 -11 1 -20 5 -20 9 0 4 -5 8 -11 8 -6 0 -22 9 -36
20 l-26 20 114 1 114 2 -141 8 c-222 12 -368 62 -451 155 -43 49 -67 122 -58
180 3 24 5 44 3 44 -2 0 -21 -30 -43 -67z m438 -320 c-7 -2 -19 -2 -25 0 -7 3
-2 5 12 5 14 0 19 -2 13 -5z"/>
<path d="M3295 5260 c-13 -6 -15 -9 -5 -9 8 0 22 4 30 9 18 12 2 12 -25 0z"/>
<path d="M3058 5253 c-10 -2 -18 -9 -18 -14 0 -13 13 -11 36 6 19 14 14 17
-18 8z"/>
<path d="M3112 5231 c-11 -7 -10 -9 3 -14 16 -7 115 10 115 20 0 4 -28 0 -89
-14 -16 -4 -22 -2 -17 6 8 13 6 14 -12 2z"/>
<path d="M6184 4028 c7 -108 92 -894 102 -940 6 -28 7 -28 83 -28 l78 0 18 43
c10 23 35 80 55 127 21 47 73 168 116 270 42 102 80 188 83 192 4 4 17 -119
29 -275 13 -155 27 -298 31 -317 l7 -35 70 -3 c49 -2 74 1 82 10 5 7 34 67 62
133 62 143 61 140 189 422 56 123 101 225 101 227 0 3 27 64 60 136 33 72 60
133 60 135 0 3 -46 5 -102 5 l-103 0 -69 -163 c-38 -89 -87 -205 -108 -257
-22 -52 -50 -118 -64 -147 -13 -28 -24 -58 -24 -65 -1 -7 -6 -23 -13 -35 -11
-19 -17 29 -41 304 -15 180 -32 335 -37 345 -7 14 -22 18 -59 18 -63 0 -41 41
-272 -500 -25 -58 -53 -126 -63 -153 -10 -26 -19 -46 -21 -45 -1 2 -12 131
-23 288 -29 396 -28 392 -43 401 -7 5 -53 9 -102 9 l-89 0 7 -102z"/>
<path d="M8583 4123 l-62 -4 -11 -52 c-6 -29 -22 -113 -35 -187 -40 -225 -64
-355 -105 -573 -22 -114 -40 -217 -40 -227 0 -18 7 -20 95 -20 90 0 95 1 99
23 8 35 75 407 102 567 14 80 38 217 54 305 17 88 30 163 30 168 0 4 -15 6
-32 5 -18 -1 -61 -3 -95 -5z"/>
<path d="M9222 4018 c-12 -57 -26 -129 -31 -161 -13 -75 -16 -78 -52 -65 -85
30 -232 -12 -314 -89 -103 -96 -155 -221 -162 -388 -4 -105 -3 -112 24 -164
61 -118 207 -137 317 -40 48 43 52 42 58 -16 l3 -30 85 0 85 0 32 175 c18 96
39 211 47 255 8 44 33 181 55 305 22 124 45 246 50 273 l8 47 -92 0 -92 0 -21
-102z m-79 -355 c3 -5 -10 -82 -29 -173 -18 -91 -34 -175 -34 -187 0 -29 -89
-103 -132 -109 -24 -4 -40 0 -58 14 -51 41 -34 231 32 354 42 80 84 108 160
108 31 0 59 -3 61 -7z"/>
<path d="M1012 3990 c0 -19 2 -27 5 -17 2 9 2 25 0 35 -3 9 -5 1 -5 -18z"/>
<path d="M991 3902 c-5 -26 -19 -99 -30 -162 -11 -63 -27 -151 -35 -195 -8
-44 -29 -156 -45 -250 -17 -93 -33 -182 -37 -197 l-6 -28 114 0 113 0 33 198
c18 108 36 212 39 230 l5 32 158 0 c155 0 158 0 164 23 3 12 5 31 5 42 -1 12
-4 8 -8 -10 -5 -23 -12 -31 -31 -32 -22 -2 -23 -2 -5 6 15 7 5 10 -40 13 l-60
4 63 2 c34 1 62 5 62 10 0 4 -27 5 -60 4 -47 -3 -65 0 -88 16 -15 11 -43 23
-63 27 -26 5 -38 14 -48 36 -10 23 -19 29 -44 30 -26 0 -28 2 -12 8 11 5 26 6
33 4 8 -4 12 4 11 23 -1 16 -3 22 -6 13 -2 -9 -15 -19 -28 -21 -18 -4 -33 5
-64 38 -23 23 -41 50 -41 59 0 11 -7 15 -22 13 -13 -2 -22 2 -21 7 11 73 14
105 10 105 -3 0 -10 -22 -16 -48z m36 -104 c-3 -7 -5 -2 -5 12 0 14 2 19 5 13
2 -7 2 -19 0 -25z"/>
<path d="M1021 3874 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M7527 3800 c-186 -33 -309 -202 -324 -446 -13 -217 78 -317 276 -301
82 6 147 34 206 88 95 88 146 217 153 390 4 105 2 119 -18 159 -12 24 -28 49
-35 56 -46 47 -163 71 -258 54z m101 -148 c10 -12 12 -46 9 -127 -7 -201 -75
-345 -162 -345 -58 0 -75 26 -75 115 0 175 61 344 135 376 28 12 77 2 93 -19z"/>
<path d="M8303 3799 c-43 -9 -81 -33 -120 -77 l-33 -37 0 53 0 52 -84 0 c-72
0 -85 -3 -90 -17 -3 -10 -23 -122 -46 -250 -22 -127 -50 -278 -60 -335 -11
-57 -20 -109 -20 -116 0 -10 23 -12 97 -10 l97 3 7 35 c4 19 22 122 40 229 30
180 35 197 63 229 41 46 83 63 140 56 l45 -7 16 59 c9 33 21 72 26 88 5 16 9
32 9 36 0 11 -51 17 -87 9z"/>
<path d="M5163 3773 c9 -2 25 -2 35 0 9 3 1 5 -18 5 -19 0 -27 -2 -17 -5z"/>
<path d="M1128 3743 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M5112 3730 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z"/>
<path d="M5635 3710 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z"/>
<path d="M1198 3683 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z"/>
<path d="M5135 3670 l-40 -6 53 -5 c28 -2 52 -1 52 2 0 12 -24 15 -65 9z"/>
<path d="M5433 3663 c20 -2 54 -2 75 0 20 2 3 4 -38 4 -41 0 -58 -2 -37 -4z"/>
<path d="M5750 3650 c-25 -10 -39 -19 -32 -19 7 -1 22 4 33 10 11 5 39 14 62
19 34 6 37 8 12 8 -16 1 -50 -8 -75 -18z"/>
<path d="M5924 3642 c14 -16 15 -27 6 -72 -11 -56 -21 -70 -54 -70 -37 0 -151
-33 -211 -60 -68 -30 -126 -89 -145 -145 -17 -51 -9 -144 15 -177 52 -70 160
-84 253 -33 30 16 58 37 63 47 14 25 29 13 29 -23 0 -38 32 -51 114 -47 l61 3
1 90 c1 50 16 171 33 273 18 100 30 192 28 205 -2 13 -5 5 -6 -18 -1 -31 -4
-37 -12 -25 -8 11 -9 8 -5 -15 5 -25 4 -27 -5 -10 -12 25 -93 47 -109 31 -7
-7 -10 -4 -10 10 0 16 -2 17 -11 4 -8 -11 -9 -8 -4 13 3 18 2 26 -4 23 -5 -4
-12 -2 -16 4 -3 5 -11 10 -17 10 -6 0 -4 -8 6 -18z m-29 -289 c-13 -108 -59
-163 -135 -163 -47 0 -60 15 -60 70 0 71 49 123 132 139 73 15 70 17 63 -46z"/>
<path d="M3161 3634 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M1905 3630 c-16 -7 -17 -9 -3 -9 9 -1 20 4 23 9 7 11 7 11 -20 0z"/>
<path d="M2998 3633 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M5010 3605 c-1 -32 -3 -36 -10 -20 -7 17 -9 16 -10 -10 l-2 -30 -7
30 c-5 25 -8 27 -14 12 -6 -16 -16 -18 -56 -15 -27 1 -47 0 -44 -4 2 -5 -1 -8
-6 -8 -6 0 -12 17 -12 38 -1 29 -4 24 -11 -26 -11 -69 -2 -63 -117 -83 -203
-34 -319 -140 -309 -280 5 -63 23 -97 71 -133 21 -16 42 -20 95 -20 73 0 114
16 166 65 l31 29 8 -39 8 -38 61 -7 c117 -12 108 -20 108 92 0 55 8 135 19
187 27 128 44 257 38 280 -3 12 -5 3 -7 -20z m-214 -262 c-4 -38 -14 -78 -22
-91 -25 -38 -74 -63 -119 -60 -35 3 -40 7 -49 36 -21 75 28 143 123 168 76 21
75 22 67 -53z"/>
<path d="M5180 3572 c-6 -37 -20 -107 -30 -157 -40 -188 -42 -209 -31 -251 22
-79 65 -107 159 -106 55 1 166 22 177 34 2 2 5 32 7 68 3 60 2 65 -17 62 -11
-1 -41 -5 -67 -8 -44 -6 -48 -5 -59 20 -11 22 -8 52 15 179 15 84 29 163 32
176 5 24 5 24 -20 7 -25 -16 -31 -12 -28 15 1 4 -8 9 -18 12 -12 3 -20 0 -20
-7 0 -8 -14 -13 -35 -14 -24 -1 -35 3 -35 13 0 7 -4 16 -9 19 -5 3 -14 -25
-21 -62z"/>
<path d="M1948 3623 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M5668 3618 c9 -9 15 -9 24 0 9 9 7 12 -12 12 -19 0 -21 -3 -12 -12z"/>
<path d="M3185 3605 c3 -11 1 -33 -4 -50 l-9 -30 -1 27 c-1 32 -17 46 -25 21
-3 -10 -23 -117 -45 -238 -23 -121 -43 -230 -46 -242 -5 -23 -4 -23 89 -23 82
0 95 2 100 18 3 9 21 109 40 222 20 113 40 224 45 248 4 23 5 42 0 42 -4 0
-12 -19 -17 -42 l-10 -43 -2 35 c-1 29 -3 32 -10 15 -5 -11 -9 -14 -9 -7 -1 7
-16 12 -39 12 -32 0 -40 4 -50 28 -6 15 -9 18 -7 7z"/>
<path d="M1581 3593 c-1 -11 -10 -65 -21 -120 -11 -54 -32 -156 -45 -228 -14
-71 -27 -140 -30 -152 -5 -23 -4 -23 90 -23 90 0 95 1 100 23 6 28 42 226 60
334 7 45 16 87 20 93 3 6 0 7 -9 4 -9 -3 -17 -18 -17 -33 -1 -25 -2 -25 -8 4
l-7 30 -8 -29 c-4 -17 -10 -25 -14 -19 -4 6 -28 12 -54 14 -45 4 -48 3 -54
-24 -11 -52 -13 -22 -3 51 6 41 8 79 5 85 -2 7 -5 2 -5 -10z"/>
<path d="M3835 3599 c-4 -6 -5 -12 -2 -15 2 -3 7 2 10 11 7 17 1 20 -8 4z"/>
<path d="M4185 3456 c-33 -177 -56 -225 -120 -252 -47 -19 -71 -18 -96 7 -20
20 -21 29 -16 128 3 70 12 125 25 161 34 93 34 96 12 63 -12 -18 -26 -30 -31
-27 -5 3 -10 -5 -10 -18 -1 -13 -5 -6 -9 17 -4 22 -8 30 -9 18 -1 -20 -5 -22
-50 -16 -43 5 -50 3 -54 -13 -2 -11 -3 -3 -1 16 3 33 2 34 -12 15 -58 -78 -81
-329 -37 -411 60 -113 232 -121 327 -15 27 29 33 27 34 -16 1 -20 7 -40 14
-45 7 -4 45 -7 83 -6 l70 3 22 130 c12 72 31 184 42 249 13 78 17 124 11 135
-8 14 -9 13 -10 -4 -1 -18 -2 -18 -14 4 -13 23 -14 24 -20 5 -5 -18 -12 -20
-56 -14 -48 6 -50 6 -52 -19 0 -14 -4 -6 -7 19 -5 40 -9 29 -36 -114z m182 72
c-3 -8 -6 -5 -6 6 -1 11 2 17 5 13 3 -3 4 -12 1 -19z"/>
<path d="M1780 3575 c-13 -14 -22 -27 -19 -29 2 -2 14 10 27 25 29 36 24 38
-8 4z"/>
<path d="M3706 3563 c-4 -21 -12 -45 -17 -53 -8 -12 -9 -11 -5 5 5 18 1 20
-32 19 -21 0 -43 -4 -49 -7 -6 -4 -14 -1 -16 5 -4 10 -8 9 -17 -2 -8 -12 -10
-6 -6 25 3 22 3 31 -1 20 -3 -11 -11 -29 -19 -39 -12 -17 -13 -15 -7 20 3 21
3 36 -1 33 -6 -5 -96 -479 -96 -506 0 -10 22 -13 94 -13 l93 0 6 33 c3 17 24
135 47 261 22 126 39 230 36 233 -2 2 -7 -13 -10 -34z"/>
<path d="M2012 3570 c-7 -11 -8 -20 -3 -20 9 0 24 30 18 36 -1 2 -8 -6 -15
-16z"/>
<path d="M2380 3576 c0 -8 -11 -28 -25 -44 -27 -32 -90 -52 -162 -52 -38 0
-37 -5 -17 75 4 14 0 12 -13 -7 -19 -30 -33 -34 -51 -16 -9 9 -12 9 -12 0 0
-7 -7 -12 -16 -12 -10 0 -14 6 -11 14 4 10 1 13 -9 9 -7 -3 -14 -9 -14 -14 0
-13 -48 -11 -52 3 -2 6 -13 -20 -24 -58 -26 -93 -27 -255 -1 -301 49 -91 155
-134 277 -114 55 9 167 56 204 86 19 15 19 16 -4 65 -13 27 -27 50 -30 50 -4
0 -36 -15 -70 -32 -85 -44 -151 -46 -186 -4 -22 24 -25 36 -22 90 l3 61 80 7
c87 7 201 47 253 89 33 27 62 70 61 91 0 7 -6 1 -12 -13 -13 -28 -77 -87 -77
-71 0 5 7 12 15 16 8 3 14 11 13 18 -2 7 5 12 15 10 21 -4 23 14 2 22 -8 3
-15 1 -15 -4 0 -5 -22 -8 -49 -7 -48 2 -49 3 -44 30 3 15 3 27 -1 27 -3 0 -6
-6 -6 -14z"/>
<path d="M2611 3542 c-2 -63 26 -99 138 -174 86 -58 101 -100 52 -149 -38 -38
-88 -39 -160 -3 l-52 26 -23 -21 c-26 -24 -52 -93 -42 -109 3 -6 32 -20 64
-32 118 -45 282 -11 358 72 48 53 64 95 64 165 0 78 -28 116 -130 177 -73 45
-102 54 -86 27 4 -6 13 -8 21 -4 9 3 15 -1 15 -11 0 -9 8 -16 18 -17 14 0 14
-2 -3 -9 -14 -5 -24 -3 -32 8 -7 8 -30 16 -50 17 -21 1 -49 5 -62 9 -16 6 -26
4 -31 -5 -12 -18 -43 -21 -36 -3 3 8 1 14 -4 14 -5 0 -11 12 -13 28 -4 25 -4
24 -6 -6z"/>
<path d="M6945 2883 c-568 -15 -1223 -76 -2151 -202 -1252 -170 -1972 -204
-2649 -126 -86 10 19 -14 170 -40 375 -62 706 -88 1120 -88 405 1 749 23 1245
79 124 14 261 29 305 34 44 5 130 16 190 24 61 9 164 23 230 31 66 9 203 26
305 40 1351 176 2202 207 3053 109 76 -9 140 -14 143 -12 7 7 -289 56 -501 82
-462 58 -970 82 -1460 69z"/>
<path d="M1021 2866 c36 -21 244 -89 379 -124 224 -59 481 -101 825 -134 81
-8 293 -12 560 -13 584 0 755 14 2009 165 153 19 271 32 544 60 153 16 472 40
552 41 l75 1 -60 10 c-53 8 -952 4 -1030 -5 -16 -2 -66 -5 -110 -7 l-80 -4 85
-5 c81 -6 77 -7 -82 -15 -111 -5 -166 -12 -161 -19 4 -7 -7 -8 -31 -4 -20 3
-34 2 -31 -3 3 -4 -19 -10 -47 -13 -29 -3 -80 -12 -113 -20 -33 -9 -97 -23
-142 -33 -45 -9 -81 -20 -78 -23 2 -4 -15 -5 -37 -3 -28 3 -38 1 -34 -7 7 -11
-24 -21 -59 -19 -11 1 -42 0 -70 -2 -49 -3 -49 -3 -15 -10 31 -7 29 -8 -25
-10 -115 -4 -236 -17 -285 -30 -19 -5 -96 -12 -170 -14 -74 -3 -166 -7 -205
-10 -43 -3 -58 -2 -40 3 17 4 -112 8 -290 9 -349 2 -612 9 -624 16 -15 9 -264
46 -319 47 -41 1 -50 3 -32 8 27 8 31 7 -120 30 l-55 8 50 3 c50 3 50 3 -20
11 -259 32 -538 78 -659 109 -81 21 -83 22 -55 6z m3566 -52 c-3 -3 -12 -4
-19 -1 -8 3 -5 6 6 6 11 1 17 -2 13 -5z m-640 -140 c-3 -3 -12 -4 -19 -1 -8 3
-5 6 6 6 11 1 17 -2 13 -5z m-1269 -61 c-10 -2 -28 -2 -40 0 -13 2 -5 4 17 4
22 1 32 -1 23 -4z m345 0 c-13 -2 -33 -2 -45 0 -13 2 -3 4 22 4 25 0 35 -2 23
-4z"/>
<path d="M4538 2843 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M4648 2843 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z"/>
<path d="M1818 2733 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
</g>
</svg>

    </Box>
  );
  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="">{logo}</RouterLink>
}
